import {safeLocalStorage} from '../utils/safeLocalStorage.js';

export const bannerFriendDiscount =  () =>  {
    const bannerFriendDiscountContainer = document.querySelector('.js-banner-friend-discount');
    if (!bannerFriendDiscountContainer) return;
    bannerFriendDiscountContainer.querySelector('.close')?.addEventListener(
        'click', 
        ()=> safeLocalStorage.setItem('bannerFdClosed', Date.now())
    );
    bannerFriendDiscountContainer.classList.toggle(
        'd-none', 
        (safeLocalStorage.getItem('bannerFdClosed') || 0) > new Date().setDate(-15) //no ha visto el banner O hace menos de 15 dias q lo cerró
    );
}
